import { render } from "./EquipmentTypeForm.vue?vue&type=template&id=4ba00c6a"
import script from "./EquipmentTypeForm.vue?vue&type=script&lang=js"
export * from "./EquipmentTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__